import { render, staticRenderFns } from "./serviceDisplay.vue?vue&type=template&id=1a989c44&scoped=true"
import script from "./serviceDisplay.vue?vue&type=script&lang=js"
export * from "./serviceDisplay.vue?vue&type=script&lang=js"
import style0 from "./serviceDisplay.vue?vue&type=style&index=0&id=1a989c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a989c44",
  null
  
)

export default component.exports